import { render } from "./PacientesDiagnostico.vue?vue&type=template&id=032c5fea"
import script from "./PacientesDiagnostico.vue?vue&type=script&lang=js"
export * from "./PacientesDiagnostico.vue?vue&type=script&lang=js"

import "./PacientesDiagnostico.vue?vue&type=style&index=0&id=032c5fea&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__